module.exports = __webpack_public_path__ + "static/media/title_img.90a86ff7.png";